import React from 'react';

export const FundInvestorTagIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 12.7073V4.48622C12 4.15737 11.8576 3.82853 11.5778 3.57733L8.01729 0.380227C7.4527 -0.126742 6.5473 -0.126742 5.98271 0.380227L2.42218 3.57733C2.14242 3.82853 2 4.15737 2.00509 4.49079L2 12.7073C2.00509 13.0408 2.14242 13.3742 2.42218 13.6254C2.70193 13.8766 3.07324 13.9999 3.43947 13.9999H10.5605C10.9318 14.0044 11.2981 13.8766 11.5778 13.6254C11.8627 13.3696 12 13.0362 12 12.7073ZM8 3C8 3.55228 7.55228 4 7 4C6.44772 4 6 3.55228 6 3C6 2.44772 6.44772 2 7 2C7.55228 2 8 2.44772 8 3ZM8.28571 7.38462H9.4C9.733 7.38462 10 7.67215 10 8.03077L9.99999 11.3538C9.99999 11.7125 9.73299 12 9.39999 12H4.6C4.267 12 4 11.7125 4 11.3538L4.00301 8.03077C4.00301 7.67215 4.26701 7.38462 4.60001 7.38462H5.71428V6.64615C5.71428 6.28754 5.98128 6 6.31428 6H7.68571C8.01871 6 8.28571 6.28754 8.28571 6.64615V7.38462ZM6.35714 7.38462H7.64285V6.69231H7H6.35714V7.38462Z"
      fill="#757575"
    />
  </svg>
);
